import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environments';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private router: Router, private http: HttpClient) { }

  // now accepts a payload object { email, password }
  login(payload: { email: string; password: string }) {
    return this.http
      .post<any>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/login`,
        payload
      )
      .pipe(
        map((user) => {
          localStorage.setItem(
            `${environment.appName}user`,
            user.data.access_token
          );
          return user;
        })
      );
  }

  logout() {
    localStorage.removeItem(`${environment.appName}user`);
    this.router.navigate(['/login']);
  }
}
